"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
Entry.Comment = /*#__PURE__*/function () {
  function Comment(schema, board, block) {
    (0, _classCallCheck2["default"])(this, Comment);
    (0, _defineProperty2["default"])(this, "dragMode", Entry.DRAG_MODE_NONE);
    (0, _defineProperty2["default"])(this, "offsetX", 50);
    (0, _defineProperty2["default"])(this, "offsetY", 10);
    (0, _defineProperty2["default"])(this, "schema", {
      id: null,
      x: 0,
      y: 0,
      moveX: 0,
      moveY: 0,
      parentWidth: 0,
      parentHeight: 0,
      width: 160,
      height: 160,
      value: '',
      readOnly: false,
      visible: true,
      display: true,
      movable: true,
      isOpened: true,
      deletable: Entry.Block.DELETABLE_TRUE
    });
    Entry.Model(this, false);
    if (schema) {
      this.set(schema);
    }
    this.generateId(schema);
    this._block = block;
    if (block) {
      this.createComment(board, schema);
    }
    this.magnet = {};
  }
  return (0, _createClass2["default"])(Comment, [{
    key: "block",
    get: function get() {
      return this._block;
    }
  }, {
    key: "board",
    get: function get() {
      return this._board;
    }
  }, {
    key: "blockView",
    get: function get() {
      return this._blockView;
    }
  }, {
    key: "view",
    get: function get() {
      return this;
    }
  }, {
    key: "defaultLineLength",
    get: function get() {
      return 40;
    }
  }, {
    key: "titleHeight",
    get: function get() {
      return 22;
    }
  }, {
    key: "scale",
    get: function get() {
      return this.board.scale || 1;
    }
  }, {
    key: "fontSize",
    get: function get() {
      return this.scale * 10;
    }
  }, {
    key: "value",
    get: function get() {
      return this.value;
    }
  }, {
    key: "thread",
    get: function get() {
      return this._thread || this.block && this.block.thread;
    }
  }, {
    key: "code",
    get: function get() {
      if (this.board && this.board.getCode) {
        return this.board.getCode();
      }
      if (this.thread && this.thread.getCode) {
        return this.thread.getCode();
      }
    }
  }, {
    key: "textAreaPath",
    get: function get() {
      var d = '';
      var width = this.width,
        height = this.height;
      width = Math.max(width, 100);
      height = Math.max(height, 100);
      for (var y = 14; y < height - this.titleHeight - 4; y += 16) {
        d += "M6,".concat(y, " H").concat(width - 12, " ");
      }
      return d;
    }
  }, {
    key: "titleAreaPath",
    get: function get() {
      var d = '';
      d = "M0 4 C 0 2 2 0 4 0 H".concat(this.width - 4);
      d += " C ".concat(this.width - 2, " 0 ").concat(this.width, " 2 ").concat(this.width, " 4 ");
      if (this.isOpened) {
        d += "V22 H0 V4";
      } else if (this.block) {
        d = 'M0 11 C 0 5 5 0 11 0 C 17 0 22 5 22 11 ';
        d += 'C 22 17 17 22 11 22 C 5 22 0 17 0 11';
      } else {
        d += "V18 C ".concat(this.width, " 20 ").concat(this.width - 2, " 22 ").concat(this.width - 4, " 22 H4");
        d += "C 2 22 0 20 0 18 V4";
      }
      return d;
    }
  }, {
    key: "titleTextAreaPath",
    get: function get() {
      return "M22,14 H".concat(this.width - 22);
    }
  }, {
    key: "generateId",
    value: function generateId() {
      var schema = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var id = schema.id || Entry.Utils.generateId();
      this.set({
        id: id
      });
    }
  }, {
    key: "createComment",
    value: function createComment(board, schema) {
      if (board) {
        this._board = board;
      }
      var _ref = this.block || {},
        view = _ref.view;
      this._blockView = view;
      var _ref2 = this.blockView || {},
        svgGroup = _ref2.svgGroup,
        pathGroup = _ref2.pathGroup,
        svgCommentGroup = _ref2.svgCommentGroup;
      this.pathGroup = pathGroup;
      this.parentGroup = svgGroup;
      if (this.block && svgCommentGroup) {
        this.svgGroup = svgCommentGroup.prepend('g');
      } else if (this.board.svgCommentGroup) {
        this.svgGroup = this.board.svgCommentGroup.elem('g');
      } else {
        return;
      }
      this.mouseDown = this.mouseDown.bind(this);
      this.mouseMove = this.mouseMove.bind(this);
      this.mouseUp = this.mouseUp.bind(this);
      this.resizeMouseDown = this.resizeMouseDown.bind(this);
      this.resizeMouseMove = this.resizeMouseMove.bind(this);
      this.resizeMouseUp = this.resizeMouseUp.bind(this);
      this.toggleMouseDown = this.toggleMouseDown.bind(this);
      this.toggleMouseUp = this.toggleMouseUp.bind(this);
      this.startRender();
      this.initParentSize();
      if (schema) {
        this.initSchema(schema);
      }
      this.setFrame();
      this.addControl();
      this.setPosition();
      this.code && this.code.registerBlock(this);
      this.setObservers();
    }
  }, {
    key: "startRender",
    value: function startRender() {
      if (this.block) {
        this._line = this.svgGroup.elem('line');
      }
      this._contentGroup = this.svgGroup.elem('g');
      this._comment = this._contentGroup.elem('rect');
      this._path = this._contentGroup.elem('defs').elem('path');
      this._text = this._contentGroup.elem('text');
      this._textPath = this._text.elem('textPath');
      this._resizeArrow = this._contentGroup.elem('image');
      this._resizeArea = this._contentGroup.elem('rect');
      this._title = this.svgGroup.elem('path');
      this._titleGroup = this.svgGroup.elem('g');
      this._toggleArrow = this._titleGroup.elem('image');
      this._titlePath = this._titleGroup.elem('defs').elem('path');
      this._titleText = this._titleGroup.elem('text');
      this._titleTextPath = this._titleText.elem('textPath');
      this._commentIcon = this.svgGroup.elem('image');
      this._toggleArea = this.svgGroup.elem('rect');
      this.canRender = true;
    }
  }, {
    key: "initSchema",
    value: function initSchema() {
      var schema = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var titleHeight = this.titleHeight,
        defaultLineLength = this.defaultLineLength;
      var x = this.parentWidth + defaultLineLength;
      var y = this.parentHeight / 2 - titleHeight / 2;
      schema.x = schema.x || x;
      schema.y = schema.y || y;
      schema.width = schema.width || 160;
      schema.height = schema.height || 160;
      this.set(schema);
    }
  }, {
    key: "initParentSize",
    value: function initParentSize() {
      if (!this.pathGroup) {
        return;
      }
      var parentWidth = this.pathGroup.getBBox().width;
      var _this$_blockView = this._blockView,
        topFieldHeight = _this$_blockView.topFieldHeight,
        height = _this$_blockView.height;
      var parentHeight = topFieldHeight || height;
      this.set({
        parentWidth: parentWidth,
        parentHeight: parentHeight
      });
    }
  }, {
    key: "setFrame",
    value: function setFrame() {
      this._comment.attr({
        stroke: '#EDA913',
        fill: '#FFDA85',
        rx: '4'
      });
      this._title.attr({
        stroke: '#EDA913',
        fill: '#FBB315'
      });
      if (this.block) {
        this._line.attr({
          style: 'stroke:#eda913;stroke-width:2'
        });
      }
      this._path.attr({
        id: "".concat(this.id, "c"),
        stroke: 'red'
      });
      this._titlePath.attr({
        id: "".concat(this.id, "t")
      });
      this._text.attr({
        'font-size': 10
      });
      this._titleText.attr({
        'font-size': 10,
        fill: 'white',
        'font-weight': 'bold',
        "class": 'invisible'
      });
      this._textPath.attr({
        href: "#".concat(this.id, "c")
      });
      this._titleTextPath.attr({
        href: "#".concat(this.id, "t")
      });
      var path = "".concat(Entry.mediaFilePath, "block_icon/comment/");
      this._resizeArea.attr({
        width: 20,
        height: 20,
        fill: 'transparent',
        "class": 'entry-comment-resize-arrow'
      });
      this._resizeArrow.attr({
        width: 8,
        height: 8,
        href: "".concat(path, "resize_arrow.svg")
      });
      this._toggleArea.attr({
        y: this.y,
        width: 20,
        height: this.titleHeight,
        fill: 'transparent',
        "class": 'entry-comment-toggle-arrow'
      });
      this._toggleArrow.attr({
        width: 8,
        height: 5,
        href: "".concat(path, "toggle_open_arrow.svg")
      });
      this._commentIcon.attr({
        width: 12,
        height: 12,
        href: "".concat(path, "comment_icon.svg")
      });
    }
  }, {
    key: "setPosition",
    value: function setPosition() {
      if (!this.visible) {
        return;
      }
      var x = this.x,
        y = this.y;
      var width = Math.max(this.width, 100);
      var rx = 4;
      var height = Math.max(this.height, 100);
      if (!this.isOpened && this.block) {
        width = 22;
        rx = 11;
      }
      this._title.attr({
        transform: "translate(".concat(x, ", ").concat(y, ")"),
        d: this.titleAreaPath
      });
      this._comment.attr({
        x: x,
        y: y,
        width: width,
        height: height
      });
      if (this.block) {
        this._line.attr({
          x1: this.parentWidth,
          y1: this.parentHeight / 2,
          x2: x + width / 2,
          y2: y + this.titleHeight / 2
        });
      }
      this._path.attr({
        transform: "translate(".concat(x, ", ").concat(y + this.titleHeight, ")"),
        d: this.textAreaPath
      });
      this._titlePath.attr({
        transform: "translate(".concat(x, ", ").concat(y, ")"),
        d: this.titleTextAreaPath
      });
      this._resizeArea.attr({
        x: x + width - 20,
        y: y + height - 20
      });
      this._resizeArrow.attr({
        x: x + width - 14,
        y: y + height - 14
      });
      this._toggleArea.attr({
        y: y,
        x: x + width - 20,
        height: this.titleHeight
      });
      this._toggleArrow.attr({
        x: x + width - 16,
        y: y + 8
      });
      this._commentIcon.attr({
        x: x + 5,
        y: y + 5
      });
    }
  }, {
    key: "setObservers",
    value: function setObservers() {
      this._observers = [];
      this._observers.push(this.observe(this, 'updateOpacity', ['visible'], false));
      this._observers.push(this.observe(this, 'toggleContent', ['isOpened']));
      this._observers.push(this.observe(this, 'setValue', ['value']));
      this._observers.push(this.observe(this, 'setPosition', ['x', 'y', 'width', 'height', 'parentWidth', 'parentHeight', 'isOpened']));
    }
  }, {
    key: "updatePos",
    value: function updatePos() {
      this.set({
        x: this.moveX,
        y: this.moveY
      });
    }
  }, {
    key: "updateParentPos",
    value: function updateParentPos() {
      if (this.pathGroup) {
        var _this$pathGroup$getBB = this.pathGroup.getBBox(),
          parentWidth = _this$pathGroup$getBB.width;
        var _this$_blockView2 = this._blockView,
          topFieldHeight = _this$_blockView2.topFieldHeight,
          height = _this$_blockView2.height;
        var parentHeight = topFieldHeight || height;
        var beforeParentWidth = this.parentWidth,
          beforeParentHeight = this.parentHeight;
        var defferenceWidth = parentWidth - beforeParentWidth;
        var defferenceHeight = parentHeight - beforeParentHeight;
        if (defferenceWidth || defferenceHeight) {
          var x = this.x,
            y = this.y;
          x += defferenceWidth;
          y += defferenceHeight;
          this.set({
            x: x,
            y: y,
            parentWidth: parentWidth,
            parentHeight: parentHeight
          });
        }
      }
    }
  }, {
    key: "moveTo",
    value: function moveTo(x, y) {
      if (!this.display) {
        this.set({
          x: -99999,
          y: -99999
        });
      } else {
        this.set({
          x: x,
          y: y
        });
      }
    }
  }, {
    key: "moveBy",
    value: function moveBy(x, y) {
      return this.moveTo(this.x + x / this.scale, this.y + y / this.scale);
    }
  }, {
    key: "resize",
    value: function resize(x, y) {
      this.set({
        width: this.width + x,
        height: this.height + y
      });
    }
  }, {
    key: "setDragInstance",
    value: function setDragInstance(e) {
      var mouseEvent = Entry.Utils.convertMouseEvent(e);
      var matrix = this.svgGroup.getCTM();
      var _Entry$GlobalSvg$getR = Entry.GlobalSvg.getRelativePoint(matrix),
        x = _Entry$GlobalSvg$getR.x,
        y = _Entry$GlobalSvg$getR.y;
      var _ref3 = this.pathGroup && this.pathGroup.getBoundingClientRect() || {
          left: x,
          top: y
        },
        startX = _ref3.left,
        startY = _ref3.top;
      this.mouseDownCoordinate = {
        x: mouseEvent.pageX,
        y: mouseEvent.pageY,
        parentX: x,
        parentY: y
      };
      this.dragInstance = new Entry.DragInstance({
        startX: startX,
        startY: startY,
        offsetX: mouseEvent.pageX,
        offsetY: mouseEvent.pageY,
        mode: true
      });
    }
  }, {
    key: "bindDomEvent",
    value: function bindDomEvent(mouseMove, mouseUp) {
      document.addEventListener('mousemove', mouseMove);
      document.addEventListener('touchmove', mouseMove);
      document.addEventListener('mouseup', mouseUp);
      document.addEventListener('touchend', mouseUp);
    }
  }, {
    key: "removeDomEvent",
    value: function removeDomEvent(mouseMove, mouseUp) {
      document.removeEventListener('mousemove', mouseMove);
      document.removeEventListener('touchmove', mouseMove);
      document.removeEventListener('mouseup', mouseUp);
      document.removeEventListener('touchend', mouseUp);
    }
  }, {
    key: "getMouseMoveDiff",
    value: function getMouseMoveDiff(mouseEvent) {
      return Math.sqrt(Math.pow(mouseEvent.pageX - this.mouseDownCoordinate.x, 2) + Math.pow(mouseEvent.pageY - this.mouseDownCoordinate.y, 2));
    }
  }, {
    key: "mouseDown",
    value: function mouseDown(e) {
      var _this = this;
      e.stopPropagation();
      e.preventDefault();
      this.longPressTimer = null;
      if (this.board.workingEvent) {
        return;
      }
      this.board.workingEvent = true;
      if ((e.button === 0 || e.type === 'touchstart') && !this.board.readOnly) {
        this.setDragInstance(e);
        this.dragMode = Entry.DRAG_MODE_MOUSEDOWN;
        this.bindDomEvent(this.mouseMove, this.mouseUp);
        var eventType = e.type;
        this.board.set({
          dragBlock: this
        });
        if (eventType === 'touchstart' || Entry.isMobile()) {
          this.longPressTimer = setTimeout(function () {
            if (_this.longPressTimer) {
              _this.longPressTimer = null;
              _this.rightClick(e);
              _this.mouseUp(e);
            }
          }, 700);
        }
      } else if (Entry.Utils.isRightButton(e)) {
        this.rightClick(e);
      }
    }
  }, {
    key: "rightClick",
    value: function rightClick(e) {
      var disposeEvent = Entry.disposeEvent;
      if (disposeEvent) {
        disposeEvent.notify(e);
      }
      delete this.board.workingEvent;
      this.dragMode = Entry.DRAG_MODE_NONE;
      var _Entry$Utils$convertM = Entry.Utils.convertMouseEvent(e),
        x = _Entry$Utils$convertM.clientX,
        y = _Entry$Utils$convertM.clientY;
      var board = this.board;
      return Entry.ContextMenu.show(_getOptions(this), null, {
        x: x,
        y: y
      });
      function _getOptions(comment) {
        var readOnly = comment.readOnly;
        var copyAndPaste = {
          text: Lang.Blocks.copy_paste_comment,
          enable: !readOnly,
          callback: function callback() {
            Entry["do"]('cloneComment', comment.copy(), board);
          }
        };
        var copy = {
          text: Lang.Blocks.copy_comment,
          enable: !readOnly,
          callback: function callback() {
            comment.copyToClipboard();
          }
        };
        var remove = {
          text: Lang.Blocks.delete_comment,
          enable: !readOnly,
          callback: function callback() {
            Entry["do"]('removeComment', comment);
          }
        };
        var toggle = {
          text: comment.isOpened ? Lang.Blocks.fold_comment : Lang.Blocks.open_comment,
          enable: !readOnly,
          callback: function callback() {
            Entry["do"]('toggleComment', comment);
          }
        };
        var separate = {
          text: Lang.Blocks.separate_comment,
          enable: !!comment.block,
          callback: function callback() {
            Entry["do"]('separateComment', comment);
          }
        };
        var options = [copyAndPaste, copy, remove, toggle, separate];
        return options;
      }
    }
  }, {
    key: "mouseMove",
    value: function mouseMove(e) {
      e.stopPropagation();
      var mouseEvent = Entry.Utils.convertMouseEvent(e);
      if (this.dragMode === Entry.DRAG_MODE_DRAG || this.getMouseMoveDiff(mouseEvent) > Entry.BlockView.DRAG_RADIUS) {
        if (this.longPressTimer) {
          clearTimeout(this.longPressTimer);
          this.longPressTimer = null;
        }
        if (this.isEditing) {
          this.destroyTextArea();
        }
        var workspaceMode = this.board.workspace.getMode();
        if (this.dragMode !== Entry.DRAG_MODE_DRAG) {
          this.set({
            moveX: this.x,
            moveY: this.y
          });
          this.dragMode = Entry.DRAG_MODE_DRAG;
          Entry.GlobalSvg.setComment(this, workspaceMode);
          this.visible && this.set({
            visible: false
          });
          this.generateCommentableBlocks();
        }
        this.set({
          moveX: this.moveX + (mouseEvent.pageX - this.dragInstance.offsetX) / this.scale,
          moveY: this.moveY + (mouseEvent.pageY - this.dragInstance.offsetY) / this.scale
        });
        this.checkConnectableBlock();
        this.dragInstance.set({
          offsetX: mouseEvent.pageX,
          offsetY: mouseEvent.pageY
        });
        Entry.GlobalSvg.commentPosition(this.dragInstance);
      }
    }
  }, {
    key: "mouseUp",
    value: function mouseUp(e) {
      e.stopPropagation();
      if (this.longPressTimer) {
        clearTimeout(this.longPressTimer);
        this.longPressTimer = null;
      }
      if (!this.isEditing && this.isOpened && this.dragMode === Entry.DRAG_MODE_MOUSEDOWN) {
        this.renderTextArea();
      } else if (this.dragMode === Entry.DRAG_MODE_DRAG) {
        this.destroyTextArea();
        Entry["do"]('moveComment', this);
        if (this.connectableBlockView) {
          Entry["do"]('connectComment', this.toJSON(), this.connectableBlockView.block).isPass(true, true);
          this.removeSelected();
        }
      }
      if (this.board) {
        this.board.set({
          dragBlock: null
        });
        delete this.board.workingEvent;
      }
      this.removeMoveSetting(this.mouseMove, this.mouseUp);
    }
  }, {
    key: "removeMoveSetting",
    value: function removeMoveSetting(mouseMove, mouseUp) {
      var dragMode = this.dragMode;
      this.dragMode = Entry.DRAG_MODE_NONE;
      this.board.set({
        dragBlock: null
      });
      delete this.connectableBlocks;
      this.set({
        visible: true
      });
      this.setPosition();
      this.removeDomEvent(mouseMove, mouseUp);
      var gs = Entry.GlobalSvg;
      var gsRet = gs.terminateDrag(this);
      if (gsRet === gs.REMOVE && dragMode === Entry.DRAG_MODE_DRAG) {
        Entry["do"]('removeComment', this).isPass(true, true);
      }
      Entry.GlobalSvg.remove();
      delete this.mouseDownCoordinate;
      delete this.dragInstance;
    }
  }, {
    key: "addControl",
    value: function addControl() {
      var bindEvent = function bindEvent(dom, func) {
        dom.addEventListener('mousedown', func);
        dom.addEventListener('touchstart', func, false);
      };
      bindEvent(this._contentGroup, this.mouseDown);
      bindEvent(this._title, this.mouseDown);
      bindEvent(this._titleGroup, this.mouseDown);
      bindEvent(this._resizeArea, this.resizeMouseDown);
      bindEvent(this._toggleArea, this.toggleMouseDown);
    }
  }, {
    key: "updateOpacity",
    value: function updateOpacity() {
      this.visible ? Entry.Utils.removeClass(this.svgGroup, 'invisible') : Entry.Utils.addClass(this.svgGroup, 'invisible');
    }
  }, {
    key: "isReadOnly",
    value: function isReadOnly() {
      return this.readOnly;
    }
  }, {
    key: "getBoard",
    value: function getBoard() {
      return this.board;
    }
  }, {
    key: "getAbsoluteCoordinate",
    value: function getAbsoluteCoordinate() {
      var dragMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.dragMode;
      var scale = this.scale;
      var pos = null;
      var parentX = 0;
      var parentY = 0;
      var x = this.moveX || this.x;
      var y = this.moveY || this.y;
      if (this.mouseDownCoordinate) {
        parentX = this.mouseDownCoordinate.parentX;
        parentY = this.mouseDownCoordinate.parentY;
      }
      if (this.blockView && dragMode !== Entry.DRAG_MODE_DRAG) {
        x += this.blockView.getAbsoluteCoordinate().x;
        y += this.blockView.getAbsoluteCoordinate().y;
      }
      pos = {
        x: x,
        y: y,
        scaleX: x + parentX / scale,
        scaleY: y + parentY / scale
      };
      return pos;
    }
  }, {
    key: "renderTextArea",
    value: function renderTextArea() {
      var _this2 = this;
      this.isEditing = true;
      var _this$_comment$getBou = this._comment.getBoundingClientRect(),
        top = _this$_comment$getBou.top,
        left = _this$_comment$getBou.left;
      var scrollTop = document.documentElement.scrollTop;
      this.event = Entry.disposeEvent.attach(this, function () {
        _this2._textPath.textContent = _this2.value;
        _this2.destroyTextArea();
      });
      this.textArea = Entry.Dom('textarea', {
        "class": 'entry-widget-textarea',
        parent: $('body')
      });
      this.bindDomEventTextArea();
      this.textArea.val(this.value);
      this.textArea.css({
        left: left - (1 - this.scale) * 0.2 + 2,
        top: this.titleHeight * this.scale + top + 1 + scrollTop,
        'font-size': "".concat(this.fontSize, "px"),
        width: (this.width - 16) * this.scale,
        height: (this.height - this.titleHeight - 10) * this.scale,
        border: "".concat(this.scale, "px solid transparent"),
        'border-radius': "0 0 ".concat(4 * this.scale, "px ").concat(4 * this.scale, "px"),
        padding: "".concat(2 * this.scale, "px ").concat(4 * this.scale, "px")
      });
      var length = this.value.length;
      this.textArea.focus && this.textArea.focus() && this.textArea[0].setSelectionRange(length, length);
    }
  }, {
    key: "bindDomEventTextArea",
    value: function bindDomEventTextArea() {
      var _this3 = this;
      this.textArea.on('mousedown', function (e) {
        e.stopPropagation();
      });
      var exitKeys = [13, 27];
      this.textArea.on('keypress', function (e) {
        if (_.includes(exitKeys, e.keyCode || e.which)) {
          e.preventDefault();
        }
      });
      this.textArea.on('keyup', function (e) {
        if (_.includes(exitKeys, e.keyCode || e.which)) {
          _this3.destroyTextArea();
          _this3.isEditing = false;
        }
      });
      this.textArea.one('blur', function () {
        _this3.destroyTextArea();
        _this3.isEditing = false;
      });
    }
  }, {
    key: "destroyTextArea",
    value: function destroyTextArea() {
      this.isEditing = false;
      this.event && this.event.destroy();
      delete this.event;
      if (this.textArea) {
        this.textArea.remove();
        var value = this.textArea.val();
        if (this.value !== value) {
          Entry["do"]('writeComment', this, value);
        }
        delete this.textArea;
      }
      Entry.Utils.blur();
    }
  }, {
    key: "writeComment",
    value: function writeComment(value) {
      this.set({
        value: value
      });
    }
  }, {
    key: "setValue",
    value: function setValue() {
      this._textPath.textContent = this.value;
      this._titleTextPath.textContent = this.value;
    }
  }, {
    key: "resizeMouseDown",
    value: function resizeMouseDown(e) {
      e.stopPropagation();
      e.preventDefault();
      if (Entry.documentMousedown) {
        Entry.documentMousedown.notify(e);
      }
      if ((e.button === 0 || e.type === 'touchstart') && !this.board.readOnly) {
        this.setDragInstance(e);
        this.dragMode = Entry.DRAG_MODE_MOUSEDOWN;
        this.bindDomEvent(this.resizeMouseMove, this.resizeMouseUp);
      } else if (Entry.Utils.isRightButton(e)) {
        this.rightClick(e);
      }
    }
  }, {
    key: "resizeMouseMove",
    value: function resizeMouseMove(e) {
      e.stopPropagation();
      var mouseEvent = Entry.Utils.convertMouseEvent(e);
      if (this.dragMode === Entry.DRAG_MODE_DRAG || this.getMouseMoveDiff(mouseEvent) > Entry.BlockView.DRAG_RADIUS) {
        if (this.dragMode !== Entry.DRAG_MODE_DRAG) {
          this.dragMode = Entry.DRAG_MODE_DRAG;
        }
        this.resize((mouseEvent.pageX - this.dragInstance.offsetX) / this.scale, (mouseEvent.pageY - this.dragInstance.offsetY) / this.scale);
        this.dragInstance.set({
          offsetX: mouseEvent.pageX,
          offsetY: mouseEvent.pageY
        });
      }
    }
  }, {
    key: "resizeMouseUp",
    value: function resizeMouseUp(e) {
      e.stopPropagation();
      this.set({
        width: Number(this._comment.getAttribute('width')),
        height: Number(this._comment.getAttribute('height'))
      });
      this.removeMoveSetting(this.resizeMouseMove, this.resizeMouseUp);
    }
  }, {
    key: "toggleMouseDown",
    value: function toggleMouseDown(e) {
      e.stopPropagation();
      e.preventDefault();
      if (Entry.documentMousedown) {
        Entry.documentMousedown.notify(e);
      }
      if ((e.button === 0 || e.type === 'touchstart') && !this.board.readOnly) {
        this.setDragInstance(e);
        this.dragMode = Entry.DRAG_MODE_MOUSEDOWN;
        this.bindDomEvent(this.mouseMove, this.toggleMouseUp);
      } else if (Entry.Utils.isRightButton(e)) {
        this.rightClick(e);
      }
    }
  }, {
    key: "toggleMouseUp",
    value: function toggleMouseUp(e) {
      e.stopPropagation();
      if (this.dragMode === Entry.DRAG_MODE_MOUSEDOWN) {
        Entry["do"]('toggleComment', this);
      } else {
        Entry["do"]('moveComment', this);
      }
      this.removeMoveSetting(this.mouseMove, this.toggleMouseUp);
    }
  }, {
    key: "toggleContent",
    value: function toggleContent() {
      var path = "".concat(Entry.mediaFilePath, "block_icon/comment/");
      var fileName;
      if (this.isOpened) {
        Entry.Utils.removeClass(this._contentGroup, 'invisible');
        Entry.Utils.addClass(this._titleText, 'invisible');
        Entry.Utils.removeClass(this._titleGroup, 'invisible');
        fileName = 'toggle_open_arrow.svg';
      } else {
        if (this._block) {
          Entry.Utils.addClass(this._titleGroup, 'invisible');
        }
        Entry.Utils.addClass(this._contentGroup, 'invisible');
        Entry.Utils.removeClass(this._titleText, 'invisible');
        fileName = 'toggle_close_arrow.svg';
        this.destroyTextArea();
      }
      this._toggleArrow.attr({
        href: path + fileName
      });
    }
  }, {
    key: "setThread",
    value: function setThread(thread) {
      this._thread = thread;
    }
  }, {
    key: "getThread",
    value: function getThread() {
      var thread;
      if (this.block) {
        thread = this.block.getThread();
      } else {
        thread = this.thread;
      }
      return thread;
    }
  }, {
    key: "copy",
    value: function copy() {
      var cloned = this.toJSON(true);
      var _this$getAbsoluteCoor = this.getAbsoluteCoordinate(),
        x = _this$getAbsoluteCoor.x,
        y = _this$getAbsoluteCoor.y;
      cloned.x = x + 15;
      cloned.y = y + 15;
      cloned.id = Entry.Utils.generateId();
      cloned.type = 'comment';
      return cloned;
    }
  }, {
    key: "copyToClipboard",
    value: function copyToClipboard() {
      Entry.clipboard = this.copy();
    }
  }, {
    key: "connectToBlock",
    value: function connectToBlock(block) {
      var data = this.toJSON();
      var board = this.board;
      delete data.x;
      delete data.y;
      delete data.visible;
      this.destroy();
      block.connectComment(new Entry.Comment(data, board, block));
    }
  }, {
    key: "separateFromBlock",
    value: function separateFromBlock() {
      var data = this.toJSON();
      var _this$getAbsoluteCoor2 = this.getAbsoluteCoordinate(),
        x = _this$getAbsoluteCoor2.x,
        y = _this$getAbsoluteCoor2.y;
      var board = this.board;
      data.x = x;
      data.y = y;
      this.destroy();
      var comment = new Entry.Comment(data, board);
      this.board.code.createThread([comment], 0);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.board) {
        this.destroyView();
        this._destroyObservers();
        this.code.unregisterBlock(this);
      }
      if (this.block) {
        this.block.disconnectComment();
      } else {
        this.code.destroyThread(this.thread);
      }
    }
  }, {
    key: "destroyView",
    value: function destroyView() {
      this.removeControl();
      this.svgGroup && this.svgGroup.remove();
      delete this.svgGroup;
    }
  }, {
    key: "getBlocksInThreads",
    value: function getBlocksInThreads(threads) {
      var blockMap = [];
      var _iterator = _createForOfIteratorHelper(threads),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var thread = _step.value;
          var blocks = thread.getBlocks();
          var _iterator2 = _createForOfIteratorHelper(blocks),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var block = _step2.value;
              var blocksInStatement = [];
              if (block.statements) {
                blocksInStatement = this.getBlocksInThreads(block.statements);
              }
              blockMap = [block].concat((0, _toConsumableArray2["default"])(blocksInStatement), (0, _toConsumableArray2["default"])(blockMap));
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return blockMap;
    }
  }, {
    key: "generateCommentableBlocks",
    value: function generateCommentableBlocks() {
      this.connectableBlocks = [];
      this.connectableBlockCoordinate = null;
      if (this.block) {
        return;
      }
      var threads = this.code && this.code.getThreads() || [];
      var blockMap = this.getBlocksInThreads(threads);
      for (var index in blockMap) {
        var block = blockMap[index];
        if (block instanceof Entry.Block && !block.comment && block.isCommentable()) {
          var coordinate = block.view.getAbsoluteCoordinate();
          var _block$view = block.view,
            width = _block$view.width,
            height = _block$view.height,
            topFieldHeight = _block$view.topFieldHeight;
          this.connectableBlocks.push({
            id: block.id,
            x1: coordinate.scaleX,
            y1: coordinate.scaleY,
            x2: coordinate.scaleX + width,
            y2: coordinate.scaleY + (topFieldHeight || height)
          });
        }
      }
    }
  }, {
    key: "checkConnectableBlock",
    value: function checkConnectableBlock() {
      if (this.block) {
        return;
      }
      if (this.connectableBlockCoordinate && this.isOnConnectableBlock(this.connectableBlockCoordinate)) {
        return;
      }
      this.removeSelected();
      var _iterator3 = _createForOfIteratorHelper(this.connectableBlocks),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var coordinate = _step3.value;
          if (this.isOnConnectableBlock(coordinate)) {
            this.connectableBlockView = this.code.findById(coordinate.id).view;
            this.board.setSelectedBlock(this.connectableBlockView);
            this.connectableBlockCoordinate = coordinate;
            return;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "removeSelected",
    value: function removeSelected() {
      if (this.connectableBlockView) {
        this.connectableBlockView.removeSelected();
        this.connectableBlockView = null;
      }
      this.connectableBlockCoordinate = null;
    }
  }, {
    key: "isOnConnectableBlock",
    value: function isOnConnectableBlock(coordinate) {
      var x1 = coordinate.x1,
        y1 = coordinate.y1,
        x2 = coordinate.x2,
        y2 = coordinate.y2;
      var x = this.moveX,
        y = this.moveY;
      return x1 <= x && x < x2 && y1 <= y && y < y2;
    }
  }, {
    key: "isInOrigin",
    value: function isInOrigin() {
      return false;
    }
  }, {
    key: "reDraw",
    value: function reDraw() {}
  }, {
    key: "_destroyObservers",
    value: function _destroyObservers() {
      var observers = this._observers;
      while (observers.length) {
        observers.pop().destroy();
      }
    }
  }, {
    key: "removeControl",
    value: function removeControl() {
      var destroyEvent = function destroyEvent(dom, func) {
        dom.removeEventListener('mousedown', func);
        dom.removeEventListener('ontouchstart', func);
      };
      destroyEvent(this._contentGroup, this.mouseDown);
      destroyEvent(this._title, this.mouseDown);
      destroyEvent(this._resizeArea, this.resizeMouseDown);
      destroyEvent(this._toggleArea, this.toggleMouseDown);
    }
  }, {
    key: "isDeletable",
    value: function isDeletable() {
      return this.deletable;
    }
  }, {
    key: "getCode",
    value: function getCode() {
      return this.code;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var json = this._toJSON();
      json.type = 'comment';
      delete json.parentWidth;
      delete json.parentHeight;
      delete json.moveX;
      delete json.moveY;
      return json;
    }
  }]);
}();